import { useState, type FormEvent } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/daeo9r9tto0ceqqnh1c0";

export default function NewsletterForm({ compact = false }: { compact?: boolean }) {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = String(fd.get("contact_alt") || "").trim();
    setFormError("");

    // 蜜罐命中：静默当作成功处理，不向服务端提交
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }

    setStatus("loading");
    try {
      const resp = await fetch(FORM_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await resp.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const okCode = parsed?.code === "OK";
      const isSpam = /spam|form data is spam/i.test(serverMsg || "");
      if (!resp.ok || !okCode || isSpam) {
        setStatus("error");
        setFormError(serverMsg || "订阅失败，请稍后再试。");
        return;
      }
      setStatus("success");
      form.reset();
    } catch {
      setStatus("error");
      setFormError("网络异常，订阅未成功，请稍后重试。");
    }
  }

  return (
    <div className={compact ? "" : "w-full"}>
      <form id="newsletter-subscribe" data-readdy-form="newsletter" onSubmit={handleSubmit} noValidate>
        <div className="hp-check-field" aria-hidden="true">
          <label htmlFor="contact_alt">请不要填写此字段</label>
          <input
            id="contact_alt"
            type="text"
            name="contact_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
        </div>
        <div className="flex flex-col sm:flex-row gap-2.5">
          <label htmlFor="email" className="sr-only">
            邮箱地址
          </label>
          <input
            id="email"
            type="email"
            name="email"
            required
            placeholder="you@example.com"
            aria-label="邮箱地址"
            className="h-12 flex-1 rounded-full border border-background-200 bg-background-50 px-5 text-sm outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="h-12 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-medium text-background-50 hover:bg-primary-600 disabled:opacity-60 transition-colors"
          >
            {status === "loading" ? "提交中…" : "订阅推送"}
          </button>
        </div>
        {status === "error" && (
          <p role="alert" className="mt-2.5 text-xs text-primary-700">
            {formError}
          </p>
        )}
        {status === "success" && (
          <p role="status" className="mt-2.5 text-xs text-accent-700">
            订阅成功！头条解读与深度报道将第一时间推送到你的邮箱。
          </p>
        )}
      </form>
    </div>
  );
}